import { BillGenerationReportRequest, BillNumberRequest, CommonResponse, DegummingLogReq, DegummingOutputLogReq, DegummingReq, JobReportingInfoReq, LotInformationRequest, LotNumberReportResponseModel, prodOpCreateReq, prodOpOutputReq, prodOpReq, prodOpViewReq, ProductionLogResponse, ProductionProcessDashboardReq, ReportingInfoResponseModel, SubPlantTransferResponse, TransportChargesReq, WorkOrderLogReq } from '@gtpl/shared-models/production-management';
import {CommonResponse as CommonResponseModel} from '@gtpl/shared-models/sale-management'
import axios from 'axios';
import connection from './connection';

export class ProdlogService {
    URL = connection.DEPLOY_URL + '/prod-log';

    async createProdLog(values): Promise<ProductionLogResponse> {
        return await axios.post(this.URL + '/createProdLog', values)
            .then(res => {
                return res.data
            })
    }

    async getLogDetailsForId(values): Promise<SubPlantTransferResponse> {
        return await axios.post(this.URL + '/getLogDetailsForId', values)
            .then(res => {
                return res.data
            })
    }
    async getLotTrackingReportData(req:LotInformationRequest): Promise<LotNumberReportResponseModel> {
        return await axios.post(this.URL + '/getLotTrackingReportData',req)
            .then(res => {
                return res.data
            })

    }
    async getAllReportingInfo(req: JobReportingInfoReq):Promise<ReportingInfoResponseModel>{

        return await axios.post(this.URL + '/getAllReportingInfo',req)
            .then(res => {
                return res.data
            })
    }
    async getLotNumberDetails():Promise<CommonResponse>{
        
        return await axios.post(this.URL+'/getLotNumberDetails')
        .then(res => {
            return res.data
        })
    }

    async getIntakeDetailsForProductionDashboard(req?:ProductionProcessDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL+'/getIntakeDetailsForProductionDashboard',req)
        .then(res => {
            return res.data
        })
    }
    
    async getSoakingDataForProductionReport(req?:ProductionProcessDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL+'/getSoakingDataForProductionReport',req)
        .then(res => {
            return res.data
        })
    }

    async getShiftWiseDataForProductionReport(req?:ProductionProcessDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL+'/getShiftWiseDataForProductionReport',req)
        .then(res => {
            return res.data
        })
    }

    async getTotalProductionForDashboard(req?:ProductionProcessDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL+'/getTotalProductionForDashboard',req)
        .then(res => {
            return res.data
        })
    }

    async getValueAdditionQuantitiesForProduction(req?:ProductionProcessDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL+'/getValueAdditionQuantitiesForProduction',req)
        .then(res => {
            return res.data
        })
    }

    async getValueAdditionFourForProduction(req?:ProductionProcessDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL+'/getValueAdditionFourForProduction',req)
        .then(res => {
            return res.data
        })
    }

    async getBillInfoByBillNumber(req:BillNumberRequest):Promise<CommonResponseModel>{
        return await axios.post(this.URL+'/getBillInfoByBillNumber',req)
        .then(res => {
            return res.data
        })
    }

    async getWorkersInfoByBillNumber(req:BillNumberRequest):Promise<CommonResponseModel>{
        return await axios.post(this.URL+'/getWorkersInfoByBillNumber',req)
        .then(res => {
            return res.data
        })
    }

    async getDistinctBillNumber(req:BillNumberRequest):Promise<CommonResponse>{
        return await axios.post(this.URL+'/getDistinctBillNumber',req)
        .then(res => {
            return res.data
        })
    }

    async getDistinctContractorName(req:BillNumberRequest):Promise<CommonResponse>{
        return await axios.post(this.URL+'/getDistinctContractorName',req)
        .then(res => {
            return res.data
        })
    }

    async getContractorwiseBillGeneration(req?:BillGenerationReportRequest):Promise<CommonResponse>{
        return await axios.post(this.URL+'/getContractorwiseBillGeneration',req)
        .then(res => {
            return res.data
        })
    }

    async getContractorAndDayWiseData(req?:BillGenerationReportRequest):Promise<any>{
        return await axios.post(this.URL+'/getContractorAndDayWiseData',req)
        .then(res => {
            return res.data
        })
    }

    async wagesPayableVillageWise(req?: TransportChargesReq):Promise<CommonResponse>{
        return await axios.post(this.URL+'/wagesPayableVillageWise', req)
        .then(res => {
            return res.data
        })
    }

        async createLogForWorkOrder(req: WorkOrderLogReq): Promise<CommonResponse> {
            return await axios.post(this.URL + '/createLogForWorkOrder',req)
            .then(res => {
                return res.data
            })
        }

                async createLotCodeForExportBales(req: WorkOrderLogReq, transactionManager: unknown): Promise<CommonResponse> {
            return await axios.post(this.URL + '/createLotCodeForExportBales',req)
            .then(res => {
                return res.data
            })
        }

                async getWorkOrderNoForDegumming(): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getWorkOrderNoForDegumming')
            .then(res => {
                return res.data
            })
        }

                async getProductIdByWorkOrderNo(req: DegummingReq): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getProductIdByWorkOrderNo',req)
            .then(res => {
                return res.data
            })
        }

                async getQualityForDegumming(req: DegummingReq): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getQualityForDegumming',req)
            .then(res => {
                return res.data
            })
        }

                        async getWOQtyForDegumming(req: DegummingReq): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getWOQtyForDegumming',req)
            .then(res => {
                return res.data
            })
        }

                async createLogForDegumming(req: DegummingLogReq): Promise<CommonResponse> {
            return await axios.post(this.URL + '/createLogForDegumming',req)
            .then(res => {
                return res.data
            })
        }

                                async getDegummingQtyForDegumming(req?: DegummingReq): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getDegummingQtyForDegumming',req)
            .then(res => {
                return res.data
            })
        }

                        async createLogForOutputDegumming(req: DegummingOutputLogReq): Promise<CommonResponse> {
            return await axios.post(this.URL + '/createLogForOutputDegumming',req)
            .then(res => {
                return res.data
            })
        }

                        async getOpenLWorkOrdersForDegumming(): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getOpenLWorkOrdersForDegumming')
            .then(res => {
                return res.data
            })
        }

                                async getOpenVariantForDegumming(): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getOpenVariantForDegumming')
            .then(res => {
                return res.data
            })
        }

                                async getQualityVariantForDegumming(): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getQualityVariantForDegumming')
            .then(res => {
                return res.data
            })
        }

                                        async getDegummingOutProducts(): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getDegummingOutProducts')
            .then(res => {
                return res.data
            })
        }

                                        async getClosedDegummingData(req?:DegummingReq): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getClosedDegummingData', req)
            .then(res => {
                return res.data
            })
        }

            async getLotNoForProdOp(req?:prodOpCreateReq): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getLotNoForProdOp', req)
            .then(res => {
                return res.data
            })
        }

                    async createLogForProdOp(req?:prodOpReq): Promise<CommonResponse> {
            return await axios.post(this.URL + '/createLogForProdOp', req)
            .then(res => {
                return res.data
            })
        }

        
                    async getQtyInfoForInputProdOp(req?:prodOpCreateReq): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getQtyInfoForInputProdOp', req)
            .then(res => {
                return res.data
            })
        }

                            async getDataAgainstLotForProdOp(req?:prodOpCreateReq): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getDataAgainstLotForProdOp', req)
            .then(res => {
                return res.data
            })
        }

                                    async getProdOpInputData(req?:prodOpCreateReq): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getProdOpInputData', req)
            .then(res => {
                return res.data
            })
        }

                                            async createOutputProdOp(req?:prodOpOutputReq[]): Promise<CommonResponse> {
            return await axios.post(this.URL + '/createOutputProdOp', req)
            .then(res => {
                return res.data
            })
        }

                                            async getPrevOPOutputProduct(req?:prodOpCreateReq): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getPrevOPOutputProduct', req)
            .then(res => {
                return res.data
            })
        }

                                                    async getOperationForInputProd(): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getOperationForInputProd')
            .then(res => {
                return res.data
            })
        }

                                                    async getPrevOperationForInputProd(): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getPrevOperationForInputProd')
            .then(res => {
                return res.data
            })
        }

                                                    async getLotForInputProd(): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getLotForInputProd')
            .then(res => {
                return res.data
            })
        }

        
            async getPrevOpOutputCount(req?:prodOpCreateReq): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getPrevOpOutputCount', req)
            .then(res => {
                return res.data
            })
        }

        
            async getPrevOpOutputCountType(req?:prodOpCreateReq): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getPrevOpOutputCountType', req)
            .then(res => {
                return res.data
            })
        }

                
            async getProdOpViewData(req?:prodOpViewReq): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getProdOpViewData', req)
            .then(res => {
                return res.data
            })
        }

                
            async getOperationsForProdView(req?:prodOpViewReq): Promise<CommonResponse> {
            return await axios.post(this.URL + '/getOperationsForProdView', req)
            .then(res => {
                return res.data
            })
        }
}